import React, { useState } from 'react'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'




function UserCreate() {


    const [name,setName]=useState('')
    const [Username,setUserName]=useState('')
    const [email,setEmail]=useState('')
    const [password,setPassword]=useState('')
    const [gender,setGender]=useState('')
    const [mobile,setMobile]=useState('')
    const [profileStatus,setProfileStatus]=useState('')




  const navigate=useNavigate()
     

    const handleApi=(e)=>{
       
        e.preventDefault()
        axios.post('https://rahulbloging.onrender.com/createUser',{
         name:name,
         User_name:Username,
         email: email,
         password: password,
         gender: gender,
         mobile:mobile,
         profile_status: profileStatus,
        
        })
        .then((result)=>{
         console.log(result)
         alert("Create SuccessFully")
         navigate('/login')
        })
       .catch((err)=>{
         console.log(err)
 
         alert(err.response.data.msg)
       })




    }








    return (
        <div>

            <div className="container">

               

                <form id='cr' className='mt-3'>
                    <div class="mb-1">
                        <label for="exampleInputEmail1" class="form-label">Enter Name</label>
                        <input onChange={(e)=>setName(e.target.value)} type="text" class="form-control bg-dark text-white " id="exampleInputEmail1" aria-describedby="emailHelp" />
                       
                    </div>

                    <div class="mb-1">
                        <label for="exampleInputPassword1" class="form-label">Enter User Name</label>
                        <input onChange={(e)=>setUserName(e.target.value)} type="text" class="form-control bg-dark text-white" id="exampleInputPassword1" />
                    </div>

                    <div class="mb-1">
                        <label for="exampleInputPassword1" class="form-label">Enter Email</label>
                        <input onChange={(e)=>setEmail(e.target.value)} type="email" class="form-control bg-dark text-white" id="exampleInputPassword1" />
                    </div>

                    <div class="mb-1">
                        <label for="exampleInputPassword1" class="form-label">Enter Password</label>
                        <input onChange={(e)=>setPassword(e.target.value)} type="password" class="form-control bg-dark text-white" id="exampleInputPassword1" />
                    </div>

                    <div class="mb-1">
                                
                    <select onChange={(e) => setGender(e.target.value)} class="form-select form-select-md bg-dark text-white mt-3 mb-3" aria-label=".form-select-lg example">
                            <option selected>Open this for Post select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                           
                        </select>


                        {/* <label for="exampleInputPassword1" class="form-label">Enter Gender</label>
                        <input onChange={(e)=>setGender(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" /> */}
                    </div>

                    <div class="mb-1">
                        <label for="exampleInputPassword1" class="form-label">Enter mobile</label>
                        <input onChange={(e)=>setMobile(e.target.value)} type="text" class="form-control  bg-dark text-white" id="exampleInputPassword1" />
                    </div>

                    <div class="mb-1">

                    <select onChange={(e) => setProfileStatus(e.target.value)} class="form-select form-select-md mt-3 bg-dark text-white  mb-3" aria-label=".form-select-lg example">
                            <option selected>Open this for Profile_Status</option>
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                           
                        </select>

                       
                        {/* <label for="exampleInputPassword1" class="form-label">Enter Profile Status</label>
                        <input onChange={(e)=>setProfileStatus(e.target.value)} type="text" class="form-control" id="exampleInputPassword1" /> */}
                    </div>


                    <button onClick={handleApi} type="submit" class="btn btn-primary m-2">Submit</button>
                </form>




            </div>




        </div>
    )
}

export default UserCreate
